import { Skeleton } from '@//components/Skeleton';
import styles from './ProductCardSkeleton.module.scss';

const ProductCardSkeleton = () => (
  <div className={styles.card} aria-hidden="true">
    <Skeleton aspectRatio="3 / 2" radius="var(--radius-lg)" />
    <div className={styles.body}>
      <Skeleton height="16px" width="85px" />
      <Skeleton height="16px" width="120px" />
      <div className={styles.title}>
        <Skeleton height="20px" width="140px" />
        <Skeleton height="20px" width="60%" />
      </div>
    </div>
    <div className={styles.badges}>
      <Skeleton height="26px" width="65px" />
      <Skeleton height="26px" width="65px" />
      <Skeleton height="26px" width="65px" />
      <Skeleton height="26px" width="65px" />
    </div>
    <div className={styles.footer}>
      <Skeleton height="16px" width="75px" />
      <Skeleton height="32px" width="120px" />
    </div>
  </div>
);

export default ProductCardSkeleton;
